export const fallbackMessages = {
    UNSELECTED: "Please choose a selection of News Articles",
    LOADING: "Loading...",
    NO_DATA: "Your Selection of Filter(s) Returned No Data",
    DATA_ERROR: "Error loading data",
    DEFAULT_ERROR: "Error loading widget"
}
